import { createSelector } from 'reselect';
import { RootState } from '../configureStore';

const selectNavigationReducer = (state: RootState) => state.app;

const selectActiveTab = createSelector(selectNavigationReducer, (data) => data.activeTab);

export { selectActiveTab };
